import LimitsItem from './LimitsItem';
export default LimitsItem;